export default {"src":"/_next/static/media/user.7ec1bae0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};